import React from "react";
import Spacing from "../Spacing";
import SectionHeadingStyle3 from "../SectionHeading/SectionHeadingStyle3";
import { Icon } from "@iconify/react";
import { pageTitle } from "../../helpers/PageTitle";
import { useTranslation } from "react-i18next";

export default function PortfolioDetailsPage() {
  const { t } = useTranslation();
  pageTitle(t("portfolioDetails.marketing.pageTitle"));
  
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title={t("portfolioDetails.marketing.title")}
        subTitle={t("portfolioDetails.marketing.subTitle")}
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <div className="cs_portfolio_details">
          <video autoPlay loop muted style={{ width: "100%" }}>
            <source src="/videos/videoMarketingDigital.mp4" type="video/mp4" />
            {t("portfolioDetails.marketing.videoNotSupported")}
          </video>

          <Spacing lg="100" md="40" />
          <div className="cs_portfolio_details_in">
            <div className="cs_portfolio_details_right">
              <h2>
                {t("portfolioDetails.marketing.heading")}
              </h2>
              <p>
                {t("portfolioDetails.marketing.description")}
              </p>
              <ul>
                {t("portfolioDetails.marketing.features", { returnObjects: true }).map((feature, index) => (
                  <li key={index} className={index < 3 ? "mb-2" : ""}>
                    <span className="cs_extra_bold cs_color_orange_800 fs-6">
                      {feature.title}
                    </span>{" "}
                    {feature.description}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <a
            href="https://calendly.com/nicolas-rs/new-meeting"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="text-center">
              <Spacing lg="80" md="50" />
              <span className="cs_btn cs_style_1">
                {t("portfolioDetails.marketing.button")}
                <span>
                  <i>
                    <Icon icon="fa6-solid:arrow-right" />
                  </i>
                  <i>
                    <Icon icon="fa6-solid:arrow-right" />
                  </i>
                </span>
              </span>
            </div>
          </a>
          <Spacing lg="115" md="60" />
          <div className="cs_portfolio_details_gallery">
            <div>
              <img 
                src="/images/unalom/ads_campaing.jpg" 
                alt={t("portfolioDetails.marketing.gallery.image1Alt")} 
              />
            </div>
            <div>
              <img 
                src="/images/unalom/metaMarketing.jpeg" 
                alt={t("portfolioDetails.marketing.gallery.image2Alt")} 
              />
            </div>
            <div>
              <img 
                src="/images/unalom/google_ads.jpeg" 
                alt={t("portfolioDetails.marketing.gallery.image3Alt")} 
              />
            </div>
          </div>
          <a
            href="https://calendly.com/nicolas-rs/new-meeting"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="text-center">
              <Spacing lg="80" md="50" />
              <span className="cs_btn cs_style_1">
                {t("portfolioDetails.marketing.button")}
                <span>
                  <i>
                    <Icon icon="fa6-solid:arrow-right" />
                  </i>
                  <i>
                    <Icon icon="fa6-solid:arrow-right" />
                  </i>
                </span>
              </span>
            </div>
          </a>
        </div>
      </div>
      <Spacing lg="150" md="80" />
    </>
  );
}
